import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import BreakpointChecker from "../../util/breakpoint-checker";
import debounce from "../../util/debounce";

/**
 * Display content as a swiper carousel up to a specific breakpoint
 */
function ResponsiveSwiper(swiperElement)
{
    if (swiperElement === null) {
        return;
    }

    const swiperElementId = swiperElement.id;
    const hasPagination   = (swiperElement.dataset.hasPagination === "false")   ? false : true ;
    const hasNavigation   = (swiperElement.dataset.hasNavigation === "false")   ? false : true ;
    const hasCentredSlides= (swiperElement.dataset.hasCentredSlides === "false")? false : true ;
    const isLooped        = (swiperElement.dataset.loop === "false")            ? false : true ;
    const isAutoHeight    = (swiperElement.dataset.autoHeight === "false")      ? false : true ;
    const spaceBetween    = (swiperElement.dataset.spaceBetween)                ? parseInt(swiperElement.dataset.spaceBetween) : 24;
    const slidesPerView   = (swiperElement.dataset.slidesPerView)               ? parseFloat(swiperElement.dataset.slidesPerView) : 1;
    const slidesPerGroup  = (swiperElement.dataset.slidesPerGroup)              ? parseFloat(swiperElement.dataset.slidesPerGroup) : 1;
    const isAutoPlay      = (swiperElement.dataset.autoPlay === "false")        ? false : true ;
    const autoPlayDelay   = (isAutoPlay && swiperElement.dataset.autoPlayDelay) ? parseInt(swiperElement.dataset.autoPlayDelay) : 10000;
    const isResponsive    = swiperElement.classList.contains('responsive-swiper');
    const swiperUntilBreakpoint = (swiperElement.dataset.swiperUntilBreakpoint) ? swiperElement.dataset.swiperUntilBreakpoint : false ;
    const breakpointsData = (swiperElement.dataset.breakpoints) ? JSON.parse(swiperElement.dataset.breakpoints) : null;

    let swiperInit = false;
    let swiperInstance = null;
    let breakpoints = null;

    function ResponsiveSwiperResizeHandler()
    {
        breakpoints = new BreakpointChecker();

        // Enable/disable swiping
        toggleResponsiveSwiper();
    }

    if (isResponsive) {
        breakpoints = new BreakpointChecker();
        // Debounced resize listener
        window.addEventListener('resize', debounce(ResponsiveSwiperResizeHandler, 50));
    }


    function toggleResponsiveSwiper()
    {
        const slides = (swiperElement !== null) ? swiperElement.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)') : 0;
        if (slides.length) {
            if ((isResponsive && breakpoints.isBreakpoint(swiperUntilBreakpoint) === false) || !isResponsive) { // less than lg
                    if (!swiperInit) {
                        const swiperModules = [];

                        if (hasPagination === true) {
                            swiperModules.push(Pagination);
                        }

                        if (hasNavigation === true) {
                            swiperModules.push(Navigation);
                        }

                        if (isAutoPlay === true) {
                            swiperModules.push(Autoplay);
                        }

                        const swiperConfig = {
                            direction: 'horizontal',
                            modules: swiperModules,
                            init: true,
                            loop: (isLooped === true && slides.length >= 3) ? true : false,
                            autoHeight: isAutoHeight,
                            roundLengths: true,
                            centeredSlides: (hasCentredSlides === true) ? true : false,
                            centeredSlidesBounds: true,
                            slidesPerView: (slidesPerView > 0) ? slidesPerView : 1,
                            slidesPerGroup: (slidesPerGroup > 0) ? slidesPerGroup : 1,
                            spaceBetween: spaceBetween,
                            breakpoints: breakpointsData,
                        }

                        if (hasPagination === true) {
                            swiperConfig.pagination = {
                                el: `#${swiperElementId} .swiper-pagination`,
                                clickable: true
                            }
                        }

                        if (hasNavigation === true) {
                            swiperConfig.navigation = {
                                addIcons: false,
                                nextEl: `#${swiperElementId} .swiper-button-next`,
                                prevEl: `#${swiperElementId} .swiper-button-prev`,
                            };
                        }

                        if (isAutoPlay === true) {
                            swiperConfig.autoplay = {
                                delay: autoPlayDelay,
                                pauseOnInteraction: true
                            };
                        }

                        console.info('swiperConfig', swiperConfig);

                        swiperInit = true;
                        swiperInstance = new Swiper(
                            swiperElement,
                            swiperConfig
                        );
                    }
            } else {
                if (swiperInit === true) {
                    swiperInstance.destroy();
                    swiperInit = false;
                }
            }
        }
    }

    toggleResponsiveSwiper();
}

export default ResponsiveSwiper;
